angular.module('b2bLoginApp.services').factory('Area', ['$resource',
    function ($resource) {
        return $resource('targeting.json', {}, {
            'subscriptions': {url: 'subscriptions.json'}
        });
    }]);
